<template>
  <div>
    <div class="hymn" v-for="(hymn) in hymns" :key="namespace + hymn.id">
      <div>
        <span
          class="preview-link"
          @click="previewHymn(hymn)"
        >{{hymn.hymnCode}} : {{hymn.title}}</span>
        <router-link class="is-pulled-right" :to="{ path: '/edit-hymn/' + hymn.id}">Edit</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['hymns', 'namespace'],
  methods: {
    previewHymn: function (hymn) {
      this.$emit('previewhymn', {
        hymnId: hymn.id
      })
    }
  }
};
</script>

<style scoped>
.hymn {
  padding: 3px;
}
.hymn:not(last-child) {
  border-bottom: solid 1px gray;
}
.preview-link {
  cursor: pointer;
}
</style>